export default {
  main: '#252423',
  secondary: '#EBC15B',
  contrastingColor: '#ffffff',
  priceColor: '#000000',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#252423',
};
